import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "LOCALISATION PRÉCISE",
  "INTERVENTION RAPIDE",
  "SANS CASSE",
  "CAMÉRA THERMIQUE",
  "DÉTECTION ACOUSTIQUE",
  "GAZ TRACEUR",
];

export default function BrandMarquee() {
  return (
    <div className="border-y border-white/10 bg-ink py-6 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white/90">
              {item}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-aqua" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
